import {Domain, merge, restore} from 'effector';

import {rootDomain} from 'core/rootDomain';
import {ApiSortings, InnerFilters} from 'types/api';

export function createTableModel({
    defaultFilters = [],
    defaultSorting = [],
    domain = rootDomain.createDomain(),
}: {
    defaultFilters?: InnerFilters;
    defaultSorting?: ApiSortings;
    domain: Domain;
}) {
    const filtersChanged = domain.createEvent<InnerFilters>('filtersChanged');
    const pageNumberChanged = domain.createEvent<number>('pageNumberChanged');
    const pageSizeChanged = domain.createEvent<number>('pageSizeChanged');
    const sortingChanged = domain.createEvent<ApiSortings>('sortingChanged');

    const tableStateChanged = merge([
        sortingChanged,
        pageNumberChanged,
        pageSizeChanged,
        filtersChanged,
    ]);

    const filters$ = restore(filtersChanged, defaultFilters);
    const pageNumber$ = restore(pageNumberChanged, 0).reset(filtersChanged, sortingChanged);
    const pageSize$ = restore(pageSizeChanged, 20);
    const sorting$ = restore(sortingChanged, defaultSorting);

    return {
        filters$,
        filtersChanged,
        pageNumberChanged,
        pageSizeChanged,
        pageNumber$,
        pageSize$,
        sorting$,
        sortingChanged,
        tableStateChanged,
    };
}
